import { Profile } from 'views/account/profile';
import { Password } from 'views/account/password';
import { Billing } from 'views/account/billing';
import { Upgrade } from 'views/account/upgrade';
import { Users } from 'views/account/users';
import { Settings } from 'views/account/settings';
import { CRM } from 'views/account/crm';

const Routes = [
  {
    path: '/account',
    view: Profile,
    layout: 'app',
    permission: 'user',
    title: 'Perfil'
  },
  {
    path: '/account/password',
    view: Password,
    layout: 'app',
    permission: 'user',
    title: 'Password'
  },
  {
    path: '/account/billing',
    view: Billing,
    layout: 'app',
    permission: 'owner',
    title: 'Facturación'
  },
  {
    path: '/account/crm',
    view: CRM,
    layout: 'app',
    permission: 'owner',
    title: 'ZOHO CRM'
  },
  {
    path: '/account/upgrade',
    view: Upgrade,
    layout: 'app',
    permission: 'user',
    title: 'Upgrade'
  },
  {
    path: '/account/users',
    view: Users,
    layout: 'app',
    permission: 'admin',
    title: 'Users'
  },
  {
    path: '/account/settings',
    view: Settings,
    layout: 'app',
    permission: 'admin',
    title: 'Ajustes'
  },
]

export default Routes;